import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface IPlants {
    id_barragem?: string;
    data?: string;
    descricao: string;
    arquivo: File | null;
    uuid: string,
}

const create = async (data: IPlants): Promise<IPlants[] | Error> => {
    
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('./planta', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao criar Planta/Sessao.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao criar Planta/Sessao.');
    }
};

const getAll = async (uuid: string): Promise<IPlants[] | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./plantas?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar plantas');
    } catch(error) {
        console.log(error);
        return new Error((error as { message: string}).message || 'Erro ao buscar plantas');
    }
};

const get = async (uuid: string): Promise<IPlants | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./planta?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar plantas');
    } catch(error) {
        console.log(error);
        return new Error((error as { message: string}).message || 'Erro ao buscar plantas');
    }
};

const delet = async (uuid: string): Promise<IPlants | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete(`./planta?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar plantas');
    } catch(error) {
        console.log(error);
        return new Error((error as { message: string}).message || 'Erro ao buscar plantas');
    }
};

export const PlantsServices = {
    create,
    getAll,
    get,
    delet
};